<div class="d-flex justify-content-center" data-automation-id="bulk-renew-progress">
  {{ 'itemsProcessed' | translate: {processedItemsNumber, totalItemsNumber} }}
</div>
